import OAuth2SettingsSection from '@/components/settings/OAuth2SettingsSection';

export default function SettingsOAuth2() {
  return (
    <div className="space-y-6">
      <OAuth2SettingsSection />
    </div>
  );
}
